<template>
  <div class="mb-3">
    <b-form-group
      :label="$t('custom_forms.show_empty')"
      label-for="show_empty"
    >
      <b-form-checkbox
        id="show_empty"
        v-model="showEmpty"
        :checked="false"
        switch
        @change="onInputChange"
      />
    </b-form-group>
  </div>
</template>

<script>
import {onMounted, ref} from '@vue/composition-api';
import vSelect from "vue-select";

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      default: () => ({ data: [] }),
    },
    config: Object,
  },
  setup(props, {emit, root}) {
    const showEmpty = ref(false)

    onMounted(async () => {
      showEmpty.value = props.data?.data?.[0]?.showEmpty || false
    });

    function onInputChange() {
      const payload = {
        showEmpty: showEmpty.value,
      }

      emit("update:data", {
        data: [{ ...payload }] ,
      });
    }

    return {
      showEmpty,
      onInputChange,
    };
  },
};
</script>
<style lang="scss">
.v-select .vs__dropdown-toggle .vs__selected-options .vs__selected {
  text-transform: none !important;
}
</style>
